module.exports = __webpack_public_path__ + "img/宣传_124.d9adf6de.jpg";